const index = () => import('./pages/index')

export default[
  {
    path: '/payer_assignors',
    name: 'payers.assignments',
    component: index,
    meta: { requiresAuth: true }
  }
]



// WEBPACK FOOTER //
// ./src/features/payer_assignors/routes.js